<template>
	<div>
		<div class="head">
			<img src="@/assets/headImg/head.jpg" style="width: 100%;" />
			<div class="retrun_pc" @click="retrun">返回</div>
		</div>
		<div>
			<pcBack></pcBack>
		</div>
		
		<div class="head-box" v-for="(item,index) in imgList">
			<img :src="item.url" style="width: 100%;" v-show="$route.query.myindex == item.id" />
		</div>


		<div class="head-box">
			<img src="@/assets/details/333.jpg" v-show="$route.query.myindex == 'zuhui'" style="width: 100%;" class="img-box2" />
		</div>

		<div class="btn-box">
			<div class="retrun_phone" @click="phone_return">返回</div>
			<div class="retrun_phone" @click="retrun_home">返回首页</div>
		</div>

		<div style="height: 50px"></div>
	</div>
</template>

<script>
	import pcBack from '../../components/back/back.vue';

	export default {
		data() {
			return {
				imgList: [{
						url: require('@/assets/details/1.jpg'),
						id: 1
					},
					{
						url: require('@/assets/details/2.jpg'),
						id: 2
					},
					{
						url: require('@/assets/details/3.jpg'),
						id: 3
					},
					{
						url: require('@/assets/details/4.jpg'),
						id: 4
					},
					{
						url: require('@/assets/details/5.jpg'),
						id: 5
					},
					{
						url: require('@/assets/details/6.jpg'),
						id: 6
					},
					{
						url: require('@/assets/details/7.jpg'),
						id: 7
					},
					{
						url: require('@/assets/details/8.jpg'),
						id: 8
					},
					{
						url: require('@/assets/details/9.jpg'),
						id: 9
					},
					{
						url: require('@/assets/details/10.jpg'),
						id: 10
					},
					{
						url: require('@/assets/details/11.jpg'),
						id: 11
					},
					{
						url: require('@/assets/details/12.jpg'),
						id: 12
					},

				],
			}
		},
		methods: {
			retrun: function() {
				this.$router.push({
					query: {
						id: (this.$route.query.myindex >= 7 ? 2 : 1)
					},
					path: '/schedule',
				})
			},
			phone_return() {
				this.$router.push({
					query: {
						id: (this.$route.query.myindex >= 7 ? 2 : 1)
					},
					path: '/schedule-phone',
				})
			},
			retrun_home() {
				this.$router.push({
					path: '/',
				})
			}
		},
		mounted() {
			console.log(this)
		},
		components: {
			pcBack
		},
	}
</script>

<style scoped>
	.head-box {
		width: 900px;
		margin: 0 auto;
		/* border: 3px solid #0f40d4;
  border: 3px solid #0f40d4;
  border-bottom:none;
  border-top:none;
  box-sizing: border-box;
  vertical-align: top; */


	}

	.retrun {
		margin: 20px 0;
		cursor: pointer;
		color:rgb(20, 90, 245);
		font-size: 1.125rem;
		font-weight: bold;
		display: inline-block;
	}
	.retrun_pc {
		margin: 20px 0;
		cursor: pointer;
		color: rgb(20, 90, 245);
		font-size: 1.125rem;
		font-weight: bold;
		display: inline-block;
	}
	
	.retrun_pc:hover {
		color: #49a8eb;
	}
	.phone_return {
		margin: 20px 0;
		cursor: pointer;
		color:rgb(20, 90, 245);
		font-size: 1.125rem;
		font-weight: bold;
		display: inline-block;
	}

	.img-box2 {
		margin: 3px;
	}

	.head {
		width: 980px;
		margin: 0 auto;
	}

	.ishow2 {
		display: none;
	}

	@media (max-width: 500px) {
		.head {
			width: 100%;
			margin: 0 auto;
		}

		.head-box {
			width: 100%;
			margin: 0 auto;
		}

		.retrun_pc {
			display: none;
		}
		.retrun {
			display: none;
		}

		.ishow2 {
			display: block;
		}

	}
	.retrun_phone {
		margin: 0 auto;
		line-height: 40px;
		text-align: center;
		background-color: #5e89ff;
		color: #fff;
		border-radius: 5px;
		width: 40%;
	
	}
	.btn-box{
		display: flex;
		position: fixed;
		width: 100%;
		background-color: #fff;
		bottom: 0;
	}
	@media (min-width: 500px) {
		.phone_return {
			display: none;
		}
		.retrun_phone {
			display: none;
		}
		.retrun {
			display: none;
		}
	}
</style>
